// ===========================================
// Layout Toggle Component
// ===========================================
// Toggle button for switching between professional and fun dashboard layouts

import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import {
  AutoAwesome as FunIcon,
  School as ProfessionalIcon,
} from '@mui/icons-material';
import { useStudentLayout } from '../../contexts/StudentLayoutContext';

interface LayoutToggleProps {
  showLabel?: boolean;
}

export default function LayoutToggle({ showLabel = true }: LayoutToggleProps) {
  const { layoutMode, toggleLayout } = useStudentLayout();

  const isFun = layoutMode === 'fun';

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      {showLabel && (
        <Typography variant="body2" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
          {isFun ? 'Fun Mode' : 'Classic Mode'}
        </Typography>
      )}
      <Tooltip title={isFun ? 'Switch to Classic Mode' : 'Switch to Fun Mode'}>
        <IconButton
          onClick={toggleLayout}
          size="small"
          sx={{
            bgcolor: isFun ? 'secondary.main' : 'grey.200',
            color: isFun ? 'primary.main' : 'text.secondary',
            '&:hover': {
              bgcolor: isFun ? 'secondary.dark' : 'grey.300',
              transform: 'scale(1.05)',
            },
            transition: 'all 0.2s ease-in-out',
          }}
        >
          {isFun ? <FunIcon /> : <ProfessionalIcon />}
        </IconButton>
      </Tooltip>
    </Box>
  );
}
